export default "__VITE_ASSET__ILnT4LdK__"